var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-collect"},[_c('catalog-tree',{ref:"catalogTree",attrs:{"categoryType":"ProdFavoriteDir","viewHeight":"calc(100vh - 53px)","affixTop":"32px","title":"收藏目录","defaultNode":[{DirName: '我的桌面', DirID: 0, TreeID: 'list_0'}]},on:{"dirChanged":_vm.dirChanged}}),_c('prod-list',{ref:"prodListRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }